import React from "react";
import { ShieldCheck, Award, Users, Lightbulb, Handshake, Target, Eye } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { aboutImages, pageBanner } from "../mock";
import { translations } from "../translations";
import { useLanguage } from "../context/LanguageContext";

const valueIcons = [ShieldCheck, Award, Users, Lightbulb, Handshake];

const About = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const a = t.about;

  return (
    <div>
      <PageHero title={a.pageTitle} image={pageBanner} />

      <section className="py-20 bg-white">
        <div className="max-w-[1000px] mx-auto px-5 lg:px-8 text-center">
          <Reveal>
            <p className="text-sky-accent tracking-[0.16em] text-sm uppercase font-medium">{a.valuesTagline}</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold brand-navy mt-5 dash-center">{a.heading}</h2>
          </Reveal>
          <div className="mt-10 space-y-6 text-left">
            {a.intro.map((p, i) => (
              <Reveal key={i} delay={i * 80}><p className="text-slate-600 leading-relaxed">{p}</p></Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-steel">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8 grid md:grid-cols-2 gap-8">
          <Reveal>
            <div className="bg-white/5 border border-white/15 rounded-sm p-9 h-full">
              <div className="w-12 h-12 rounded-full bg-sky-accent text-white flex items-center justify-center"><Target size={22} /></div>
              <h3 className="font-serif text-2xl font-bold text-white mt-6">{a.missionTitle}</h3>
              <p className="text-white/80 mt-4 leading-relaxed">{a.mission}</p>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="bg-white/5 border border-white/15 rounded-sm p-9 h-full">
              <div className="w-12 h-12 rounded-full bg-sky-accent text-white flex items-center justify-center"><Eye size={22} /></div>
              <h3 className="font-serif text-2xl font-bold text-white mt-6">{a.visionTitle}</h3>
              <p className="text-white/80 mt-4 leading-relaxed">{a.vision}</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
          <Reveal className="text-center">
            <h2 className="font-serif text-3xl md:text-4xl font-bold brand-navy dash-center">{a.valuesTitle}</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6 mt-14">
            {a.values.map((v, i) => {
              const Icon = valueIcons[i] || ShieldCheck;
              return (
                <Reveal key={v.title} delay={i * 80}>
                  <div className="bg-[#f6f8f6] rounded-sm p-6 h-full text-center hover:shadow-lg transition-shadow duration-300">
                    <div className="w-14 h-14 mx-auto rounded-full bg-steel text-white flex items-center justify-center"><Icon size={24} /></div>
                    <h3 className="font-serif text-base font-bold brand-navy mt-5">{v.title}</h3>
                    <p className="text-slate-600 text-sm mt-3 leading-relaxed">{v.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
